import React, { useState } from "react";
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import { Typography } from "@mui/material"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "../../css/seller/ListTransaction.css";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';
import "../../css/seller/pesanan.css"
import LoadingScreen from "../../components/LoadingScreen";
import Alert from "../../components/Alert";
import DeleteConfirm from "../../components/DeleteConfirm";

export default function SellerPesanan() {
  const [user, setUser] = React.useState({})
  const headerTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '29px',
    color: '#000000',
    textAlign: 'center'
  }

  const rowTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    color: '#000000',
  }

  const [cookies, setCookie] = useCookies(['accessToken']);
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [confirmActive, setConfirmActive] = useState(false);
  const [id, setId] = useState(0);
  const [message, setMessage] = useState('');
  const [filter, setFilter] = useState('')
  const [transaction, setTransaction] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    const validateAccessToken = async () => {
      try {
        setIsLoading(true);
        const url = `https://w-shop-backend.vercel.app/api/transactionsSeller/order?codeTrans=${filter}`; console.log(url);
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        });
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error(response.message);
        } else {
          setTransaction(response.data);
          console.log(response.data);
        }
        setIsLoading(false)
      } catch (error) {
        console.log(error);
      }
    }

    if (cookies.accessToken === '') {
      navigate('/sellerLogin');
    } else {
      validateAccessToken();
    }
  }, [cookies, filter, navigate, setCookie])

  function createData(id, codeTrans, user, product, amount, totalPrice, transactionTime, buttonAksi) {
    return { id, codeTrans, user, product, amount, totalPrice, transactionTime, buttonAksi };
  }
  const rows = [];
  let amountOrder = 0;
  transaction.map((transactions) => {

    return (transactions.status === null ? (rows.push(createData(
      transactions.id, transactions.codeTrans, transactions.user.name,
      transactions.product.product,
      transactions.amount,
      new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(transactions.price * transactions.amount),
      new Date(transactions.updatedAt).toLocaleString())),
      amountOrder += 1
    ) : (null))
  });

  let sort = rows.reverse();

  const limit = [];
  let n = 0
  sort.length < 20 ? n = 20 : n = sort.length
  for (let index = 0; index < n; index++) {
    if (sort[index] !== undefined) {
      limit.push(sort[index]);
    } else {
      limit.push(createData('', '', '', '', '', '', ''))
    }
  }

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  const handleAcceptTrans = async (id, confirm, message) => {
    setIsLoading(true);
    try {
      const url = `https://w-shop-backend.vercel.app/api/transactions/${id}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + cookies.accessToken,
        },
        body: JSON.stringify({ confirm: confirm, message: message })
      });
      const body = await response.json();
      if (body.status !== "success") {
        throw new Error(body.message);
      } else {
        const event = {
          type: "alert",
          alert: {
            type: "success",
            message: "Produk ditambahkan ke keranjang",
          },
        };
        setCookie("event", event, { path: "/" });
        setAlert(event.alert);
        activateAlert();
        setTimeout(() => {
          window.location.reload();
        }, 100);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const handleShowConfirm = (id, confirm) => {
    setConfirmActive(true);
    setId(id)
  };

  const handleHideConfirm = () => {
    setConfirmActive(false);
  };

  const inputMessage = <input type="text" className=" ms-auto me-auto d-block" onChange={(e) => { setMessage(e.target.value) }} />

  let pesananSeller = (<div>
    <Alert active={alertActive} type={alert.type} message={alert.message} />
    <LoadingScreen active={isLoading} />
    <DeleteConfirm
      active={confirmActive}
      message="Alasan menolak pesanan"
      inputMessage={inputMessage}
      cancelHandler={handleHideConfirm}
      buttonMessage='Tolak'
      deleteHandler={() => {
        handleAcceptTrans(id, { confirm: false }, message)
      }}
    />
    <div className="mainPesanan m-5 ms-auto me-auto p-5">
      <h1 className="pToko">Pesanan</h1>
      <hr />
      <div>
        <div className="input-group categoryFilter">
          <p className="pt-1"> Kode Transaksi </p>
          <input className="form-control searchPesanan ms-3 d-block" type="search" placeholder="Cari" aria-label="Search" onChange={(e) => { setFilter(e.target.value) }} />
        </div>
      </div>
      <h1 className="jumlahPesanan">{amountOrder} Pesanan</h1>
      <div className="backgroundTable">
        <p className="tableTitle">Last Transactions</p>
        <TableContainer component={Paper} sx={{ marginBottom: '10px' }}>
          <Table aria-label="a dense table">
            <TableHead className="headerTable">
              <TableRow >
                <TableCell sx={headerTable}>Kode Transaksi</TableCell>
                <TableCell sx={headerTable}>Pembeli</TableCell>
                <TableCell sx={headerTable} >Produk</TableCell>
                <TableCell sx={headerTable} >Jumlah</TableCell>
                <TableCell sx={headerTable} >Total Harga</TableCell>
                <TableCell sx={headerTable} >Waktu Transaksi</TableCell>
                <TableCell sx={headerTable} >Aksi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody >
              {limit.map((row, i) => (
                <TableRow key={i} sx={{ height: '0px', }}>
                  <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px', background: 'rgba(0, 102, 255, 0.25)' }}>
                    <Typography sx={rowTable}>{row.codeTrans}</Typography>
                  </TableCell>
                  <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px', }}><Typography sx={rowTable}>{row.user}</Typography></TableCell>
                  <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.product}</Typography></TableCell>
                  <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.amount}</Typography></TableCell>
                  <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.totalPrice}</Typography></TableCell>
                  <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.transactionTime}</Typography></TableCell>
                  <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px', minWidth: "200px", textAlign: 'center' }}>
                    {sort[i] === row ? (<>
                      <button className="btn btn-outline-success me-3 border-0" onClick={() => { handleAcceptTrans(row.id, true) }}>Terima</button>
                      <button className="btn btn-outline-danger me-3 border-0" onClick={() => { handleShowConfirm(row.id, false) }}>Tolak</button>
                    </>) : (<></>)
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <hr />
    </div >
  </div>)

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={pesananSeller} titleAppBar={"Pesanan Saya"} />
    </div>
  );
}
